<div class="padding bg-light-grey">
	<div class="flex center">Photographers</div>
</div>

<div class="padding page-layout">
	<div class="flex margin-bottom">
		<div class="flex-1 flex center">
			<h4>Search Photographers</h4>
		</div>
	</div>

	<div class="chip-container flex wrap margin-bottom">
		@for (element of filtersList; track element) {
			@let label = getLabel(element.id);
			<div (click)="openDialogFilter(element.id)" class="filter-chip" [ngClass]="!label ? ' ' : 'selected'" [title]="getFullTitleFilter(element.id)">
				@if (label) {
					<b>{{ element.label }}</b>
					: {{ label }}
					<mat-icon (click)="clearFilter($event, element.id)">close</mat-icon>
				} @else {
					{{ element.label }}
					<mat-icon>edit</mat-icon>
				}
			</div>
		}
	</div>

	<bt-loader [loaderId]="photographersLoaderId">
		@if (photographers.data) {
			<table class="basic-table">
				<tr>
					<th>Name</th>
					<th>Start Contract</th>
					<th>End Contract</th>
					<th>Status</th>
					<th>Brands</th>
					<th>Shot cost</th>
					<th>Total</th>
					<th>Actions</th>
				</tr>
				@for (item of photographers.data; track item) {
					<tr>
						<td>{{ item.fullName }}</td>
						<td>{{ parseDate(item.hiredFrom) | date: 'dd/MM/yyyy' }}</td>
						<td>{{ parseDate(item.hiredUntil) | date: 'dd/MM/yyyy' }}</td>
						<td>{{ item.statusName }}</td>
						<td>{{ getBrandColumnValue(item) }}</td>
						<td>{{ item.shotCost }}</td>
						<td>{{ item.totalPaid }}</td>

						<td>
							<div class="flex center">
								<span class="hover flex center primary margin-right">
									<i class="fa fa-list margin-right-small"></i>
									Orders
								</span>

								<span class="hover flex center primary margin-right" (click)="editPhotographer(item)">
									<i class="fa fa-edit margin-right-small"></i>
									Edit info
								</span>

								<span class="hover flex center primary margin-right" (click)="createCustomOrder(item)">
									<i class="fa fa-plus-circle margin-right-small"></i>
									Make custom order
								</span>

								<span class="hover flex center red" (click)="openDeletePhotographerDialog(item)">
									<i class="fa fa-trash margin-right-small"></i>
									Delete
								</span>
							</div>
						</td>
					</tr>
				}
			</table>
		}
	</bt-loader>

	<ng-template #discountColumn let-row="row">
		<span>{{ row.discountPercentage }}%</span>
	</ng-template>
	<ng-template #discountThresholdColumn let-row="row">
		<span>{{ row.discountThreshold | currency: 'EUR' }}</span>
	</ng-template>
	<ng-template #automaticRenewalColumn let-row="row">
		<span style="display: flex; justify-content: center">
			<i
				class="fa-solid"
				style="font-size: x-large"
				[ngClass]="row.automaticRenewal ? 'fa-circle-check' : 'fa-circle-xmark'"
				[ngStyle]="{ color: row.automaticRenewal ? 'green' : 'red' }"></i>
		</span>
	</ng-template>
	<ng-template #hiredFromColumn let-row="row">
		<span>{{ parseDate(row.hiredFrom) | date: 'dd/MM/yyyy' }}</span>
	</ng-template>
	<ng-template #hiredUntilColumn let-row="row">
		<span>{{ parseDate(row.hiredUntil) | date: 'dd/MM/yyyy' }}</span>
	</ng-template>
	<ng-template #ordersHistoryColumn let-row="row">
		<span>
			<div (click)="openOrdersHistory(row.personId)" class="open-history-button">
				<i class="fa-solid fa-up-right-from-square"></i>
			</div>
		</span>
	</ng-template>
	<ng-template #montlyPaidColumn let-row="row">
		<span>{{ row.monthlyPaid | currency: 'EUR' }}</span>
	</ng-template>
	<ng-template #shotCostColumn let-row="row">
		<span>{{ row.shotCost | currency: 'EUR' }}</span>
	</ng-template>
	<ng-template #totalPaidColumn let-row="row">
		<span>{{ row.totalPaid | currency: 'EUR' }}</span>
	</ng-template>

	<!-- @if (tmpPhotog && currentSidebar === sidebarType.deleteAction) {
	<bt-sidebar sidebarTitle="Dismiss photographer" (exit)="tmpPhotog = null">
		<div class="flex overflow column">
			<div class="flex-1 flex center">
				<div>
					Are you sure you want to
					<b>delete</b>
					{{ tmpPhotog.fullName }}? Deleting photographer, you will remove him from the application
				</div>
			</div>
			<div class="flex-0">
				<button class="full-width warning" (click)="deletePhotographer()">
					<i class="fa fa-trash"></i>
					Delete photographer
				</button>
			</div>
		</div>
	</bt-sidebar>
} -->

	@if (showModal) {
		<bt-modal modalTitle="Filters" [modalContent]="modalContent" (exit)="closeModal()" />
	}
</div>
